import { METRICS, PeriodType, REVENUE_BASIS } from "constants/revenueMetrics";
import {
  CustomerGrowth,
  PeriodicTotalAmount,
  TableData,
  TopCustomer,
} from "types/Models/revenueMetrics";
import { emptyApi } from "./emptyApi";
import { Pagination } from "types/Models/pagination";
import { ACCOUNTING_METHODS } from "constants/bookkeeping";
import { REVENUE_DATA_SOURCE_TYPES } from "constants/revenueDataSource";

type ValueOf<T> = T[keyof T];

export type RevenueMetricsResponse = {
  periodic_total_amounts: PeriodicTotalAmount[];
  customers: TableData[];
  top_customers: TopCustomer[];
  customer_growth: CustomerGrowth[];
  mrr: number;
  arr: number;
} & Pagination;

export type RevenueMetricsParams = {
  groupId: string;
  entityId: string;
  revenue_basis: keyof typeof REVENUE_BASIS;
  period_type?: PeriodType;
  start_date: string;
  end_date: string;
  metric_type: ValueOf<typeof METRICS>;
  accounting_method?: keyof typeof ACCOUNTING_METHODS;
  source?: REVENUE_DATA_SOURCE_TYPES[];
  search?: string;
  page_num: number;
};

export const revenueMetrics = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getAllRevenueMetrics: build.query<
      RevenueMetricsResponse,
      RevenueMetricsParams
    >({
      query: ({
        groupId,
        entityId,
        revenue_basis,
        period_type,
        start_date,
        end_date,
        metric_type,
        accounting_method,
        source,
        search,
        page_num,
      }) => {
        return {
          url: `/api/inkle/bookkeeping/group/${groupId}/entity/${entityId}/revenue-metrics/all/`,
          params: {
            revenue_basis,
            period_type,
            start_date,
            end_date,
            metric_type,
            accounting_method,
            source,
            search,
            page_num,
          },
        };
      },
    }),
  }),
});

export const { useGetAllRevenueMetricsQuery } = revenueMetrics;
